<template>
  <v-container>
    <div style="height: 80px"></div>
    <v-row>
      <!-- TODO: AQUI VA EL MENU  DE EDICION -->
    </v-row>
    <v-row v-if="postInfo != null" justify="center">
      <v-col cols="11" md="7" lg="6" class="test-area">
        <v-row justify="center">
          <v-col cols="12">
            <h1 class="post-title">{{ postInfo.batitulo }}</h1>
          </v-col>
          <v-col cols="12">
            <div style="display: flex; flex-direction: row">
              <div style="width: 70px">
                <img class="blog-autor-container-style"
                  v-bind:src="'https://www.ausa.com.mx/img/ausa_logo_vector_v3.png'" alt="logo_ausa" />
              </div>

              <div class="blog-title-container">
                <p class="autor-text-style">{{ postInfo.uslogin }}</p>
                <p class="fecha-text-style">
                  {{ postInfo.bafhpublicacion }}
                  <v-icon size="20" class="ml-1"> mdi-eye </v-icon>
                  <strong> {{ postInfo.balecturas }} </strong>
                </p>
              </div>

              <div class="mt-5">
                <div style="display: flex" v-if="postInfo.TieneLike == 0">
                  <v-btn text style="margin-left: auto" @click="clickOnLike()">
                    <v-icon size="16" style="margin-right: 5px">mdi-thumb-up</v-icon>
                    Me Gusta
                  </v-btn>

                  <div style="float: right">
                    <v-avatar color="primary" size="35" tile>
                      <span style="color: #ffffff">
                        {{ postInfo.CantidadLikes }}
                      </span>
                    </v-avatar>
                  </div>
                  <div style="float: right" class="ml-1">
                    <v-btn color="primary" class="share-btn-style" tile @click="clickOnShare()">
                      <v-icon>mdi-share</v-icon>
                    </v-btn>
                  </div>
                </div>

                <div style="display: flex" v-if="postInfo.TieneLike == 1">
                  <v-btn text style="margin-left: auto" color="primary" :elevation="0" @click="clickOnDislike()">
                    <v-icon size="16" style="margin-right: 5px">mdi-thumb-up</v-icon>
                    Me Gusta
                  </v-btn>

                  <div style="float: right">
                    <v-avatar color="primary" size="35" tile>
                      <span style="color: #ffffff">
                        {{ postInfo.CantidadLikes }}
                      </span>
                    </v-avatar>
                  </div>
                  <div style="float: right" class="ml-1">
                    <v-btn color="primary" class="share-btn-style" tile :elevation="0" @click="clickOnShare()">
                      <v-icon size="25">mdi-share</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" class="my-1">

            <div class="thumbnail">
              <div v-if="postInfo.baEnAmazonS3 == 1">
                <img v-bind:src="postInfo.baimagen" :alt="postInfo.badesc" class="image-rounded-style" />
              </div>
              <div v-else>
                <img v-bind:src="dynamicRoute + postInfo.baimagen" :alt="postInfo.badesc" class="image-rounded-style" />
              </div>
            </div>
          </v-col>

          <v-col cols="12" class="mt-1">
            <div class="editor-just-read">
              <vue-editor disabled v-model="htmlContent"></vue-editor>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-snackbar color="primary" v-model="snackbar" :timeout="3000">
      ¡Link copiado en el portapapeles!
    </v-snackbar>
  </v-container>
</template>


<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import BlogService from "@/services/Blogs/Blogs.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import { VueEditor, Quill } from "vue2-editor";

export default {
  components: {
    VueEditor,
  },
  props: ['tokenData'],
  data() {
    return {
      tokenInfo: [],
      postInfo: null,
      htmlContent: "",
      dynamicRoute: "",
      snackbar: false,
    };
  },
  computed: {
    ...mapState([
      "domain",
      "informationPage",
    ])

  },
  async mounted() {
    this.dynamicRoute = this.domain.domainNameDev;
    await this.getTokenData();
    this.getInitialItems();
  },
  methods: {
    async clickOnShare() {
      var currentLocation = window.location;
      navigator.clipboard.writeText(currentLocation);
      this.snackbar = true;
    },

    async getTokenData() {
      let tokenData = this.tokenData;
      let getTokenData = atob(tokenData);
      this.tokenInfo = getTokenData;
    },
    async getInitialItems() {
      let reponse = await BlogService.ObtenerPostInfo(this.tokenInfo);
      this.postInfo = reponse[0];
      this.htmlContent = this.postInfo.bacontenido;
    },

    async clickOnLike() {
      this.postInfo.TieneLike = 1;
      this.postInfo.CantidadLikes = this.postInfo.CantidadLikes + 1;
      let response = await BlogService.LikeBlogPost(this.postInfo.baclave);
    },

    async clickOnDislike() {
      this.postInfo.TieneLike = 0;
      this.postInfo.CantidadLikes = this.postInfo.CantidadLikes - 1;
      let response = await BlogService.LikeBlogPost(this.postInfo.baclave);
    },
  },
};
</script>

<style>
.editor-just-read .ql-toolbar {
  border: none !important;
  display: none !important;
}

.editor-just-read .ql-clipboard {
  border: none !important;
  display: none !important;
}

.editor-just-read .ql-tooltip {
  border: none !important;
  display: none !important;
}

.editor-just-read .ql-container {
  border: none !important;
}
</style>

<style scoped>
.share-btn-style {
  height: 34px !important;
  width: 34px !important;
  min-width: 34px !important;
  padding: 0;
}

.image-rounded-style {
  border-radius: 14px;
}

.blog-autor-container-style {
  width: 65px;
  border-radius: 50%;
}

.blog-title-container {
  width: 90%;
  padding: 2px 2px 2px 10px;
}

.post-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-style: normal;
  line-height: 1.2;
  color: #2285bb;
  font-size: 34px;
  margin-bottom: 1px;
}

.fecha-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 13px;
  font-weight: 200;
  color: grey;
  margin-bottom: 0px;
}

.autor-text-style {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
}
</style>
